import React from 'react';
import { SubAccount, ClientsAPI } from 'src/api'

import {
    Chart,
    Series,
    CommonSeriesSettings,
    Legend,
    ValueAxis,
    ArgumentAxis,
    Label,
    Border,
    Tooltip,
    Export
} from 'devextreme-react/chart';

// import fullData from '../../data/scatter_conversion.json';

const palette = ['#00ced1', '#008000', '#ffd700', '#ff7f50'];

type Data = Array<{
    "timeOnPage": number,
    "pageTurns": number,
    "timeBucket": string
}>

type ScatterProps = {
    client?: SubAccount
  }
class ScatterConversion extends React.Component<ScatterProps> {
    state = {
        data: undefined,
        narrative: undefined
      }
      fetchData = (client: SubAccount) => {
        // const params = {
        //   narrative_assembly_id: "3870d92a-e82c-11ea-86cf-0e95a518f8f7",
        //   report_content_id: "16ce3654-efc5-11ea-86cf-0e95a518f8f7",
        //   sub_account_id: client.id,
        //   period_index: "1449",
        //   period_type: "monthly"
        // }
    
        ClientsAPI.getReportData(client, 'scatter_conversion.json').then(result => {
          // console.log('done', result)
          this.setState({ data: result.data });
        }).catch(error => {
          // console.log('error', error)
        })
    
        // ClientsAPI.getNarrative(client, params).then(result => {
        //   // console.log('done', result)
        //   this.setState({ narrative: result[0] });
        // }).catch(error => {
        //   // console.log('error', error)
        // })
      }
    seriesClick(e: { target: any; }) {
        const series = e.target;
        if (series.isVisible()) {
            series.hide();
        } else {
            series.show();
        }
    }
    customizeTooltip(pointInfo: { argumentText: any; valueText: any; }) {
        return {
            text: `Time on Page: ${pointInfo.argumentText} mins <br/> Number of Page Turns: ${pointInfo.valueText}`
        };
    }
    customizeText(e: { value: any; }) {
        return `${e.value}min`;
    }

    render() {
        const { data, narrative } = this.state
        const { client } = this.props;
        if (!data && client) {
          this.fetchData(client);
        }
    
        if (!data) return null;
    
        return (
            <Chart
                id="chart"
                title={'Correlation between Time on Page and\n number of Page Turns with conversions larger than 1'}
                palette={palette}
                onSeriesClick={this.seriesClick}
                dataSource={data}>
                <Tooltip enabled={true} location="edge" customizeTooltip={this.customizeTooltip} />
                <CommonSeriesSettings type="scatter" />
                <ArgumentAxis title={{ text: "Time on Page by mins" }}>
                    <Label customizeText={this.customizeText} />
                </ArgumentAxis>
                <ValueAxis title={{ text: "Number of Page Turns" }} />

                <Series
                    name="Enthusiasts"
                    argumentField="Enthusiasts_timeOnPage"
                    valueField="Enthusiasts_pageTurns"
                    point={{
                        border: {
                            visible: true,
                            color: "grey"
                        }
                    }}
                />

                <Series
                    name="Page Turners"
                    argumentField="Page Turners_timeOnPage"
                    valueField="Page Turners_pageTurns"
                    point={{
                        border: {
                            visible: true,
                            color: "grey"
                        }
                    }}
              
                />

                <Series
                    name="Special Interest"
                    argumentField="Special Interest_timeOnPage"
                    valueField="Special Interest_pageTurns"
                    point={{
                        border: {
                            visible: true,
                            color: "grey"
                        }
                    }}
                />
                <Series
                    name="Not Interested Users"
                    argumentField="Not Interested Users_timeOnPage"
                    valueField="Not Interested Users_pageTurns"
                    point={{
                        border: {
                            visible: true,
                            color: "grey"
                        }
                    }}
                />
                <Legend
                    position="inside"
                    horizontalAlignment="left"
                >
                    <Border visible={true} />
                </Legend>
                <Export enabled={true} />
            </Chart>
        )
    }
}


export default ScatterConversion;




// WEBPACK FOOTER //
// ./src/components/ReportComponents/ScatterConversion.tsx